/** @jsxImportSource @emotion/react */
import React from "react";
import ApprovedTick from "../../../../img/butter_svgs/ApprovedTick.svg?react";
import ViewBlock from "../../../../img/butter_svgs/ViewBlock.svg?react";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Text } from "../../../../components/general/Text";
import { Container, DetailsContainer, ViewTransaction } from "./ProcessingTransaction";
import { CHAINS } from "config/chains";

export const Approved: React.FC<{ tx: string; isVisible: boolean }> = ({ isVisible, tx }) => {
  const network = GlobalStore.useState(s => s.network);
  const theme = GlobalStore.useState(s => s.theme);
  if (!isVisible) {
    return null;
  }
  return (
    <Container>
      <DetailsContainer>
        <ViewBlock style={{ color: `${theme.font.primary.default} !important` }} />
        <ViewTransaction
          href={`${CHAINS[network.id].blockExplorerUrl}tx/${tx}`}
          target="_blank"
          rel="noreferrer"
        >
          <Text textStyle={"Paragraph"} size={"Large"} color={theme.font.primary.default}>
            Details
          </Text>
        </ViewTransaction>
      </DetailsContainer>
      <ApprovedTick />
    </Container>
  );
};
